import Smartphones from 'Messages/views/ConversationView/containers/Smartphones'
import Tablets from 'Messages/views/ConversationView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ConversationView = getCurrentDeviceView(Smartphones, Tablets)

export default ConversationView
